import React from "react";
import Article from "components/article";

import Image1 from '../img/articles/covid-vaccination-portal/1.jpg';
import Image2 from '../img/articles/covid-vaccination-portal/2.jpg';

import ImgPortrait from 'components/imgPortrait';
import Seo from 'components/seo';
import TwoImageWrapper from 'components/twoImageWrapper';

const CovidVaccinationPortal = () => {
  return (
    <Article
      title="Vaccination portal"
      description="COVID Vaccination planner for Schleswig-Holstein"
      from="2020"
      to="2021"
      roles={["Product Designer", "Web Developer"]}
      text={
        <>
          <p>
            The COVID Vaccination Shift Planner was used to distribute doctors
            to vaccination centers and vaccination shifts in Schleswig-Holstein.
          </p>
          <p>
            The application was designed and developed within a few weeks for
            the KVSH (Kassenärztliche Vereinigung Schleswig-Holstein) and later
            extended to include additional features such as shift exchange,
            vaccine delivery management, and vaccine shortage notifications.
          </p>
        </>
      }
      more={
        <>
          <Seo title="Vaccination Portal" />
          <TwoImageWrapper>
            <ImgPortrait img={Image2} aspectRatio={10 / 16} />
            <ImgPortrait img={Image1} aspectRatio={10 / 23} />
          </TwoImageWrapper>
        </>
      }
    />
  );
};

export default CovidVaccinationPortal;
